import React from 'react';
import ex from 'utils/ex';

import './Floatings.css';
import hotkey from 'utils/hotkey';

const Wrap = (props) => {
  const {
    className,
    escapable,
    events,
    children,
    ...rest
  } = props || {};
  React.useEffect(() => {
    if (!escapable) return;
    const cancel = hotkey(['Escape']);
    const onKeyDown = (e) => {
      cancel(e, () => events?.onClose());
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [escapable, events?.onClose]);
  return (
    <div {...ex(className)}>
      {children}
    </div>
  )
}

export default function Floatings(props) {
  const {
    category,
    outlets = {},
    floatings = [],
    ...rest
  } = props || {};

  return (
    <div {...ex('Floatings', rest)}>
      {floatings.map((floating, index) => {
        const front = index === floatings.length - 1;
        const Component = outlets[floating.type];
        return Component && (
          <Wrap key={floating?.props?.key || index} {...ex({ front }, floating)}>
            <Component {...floating} {...{ category }} />
          </Wrap>
        );
      })}
    </div>
  );
}